// Lx720: add an url for showing the registration form automatically
window.addEventListener('load', function() {
    if( document.URL.includes("#sign-up") || document.URL.includes("#signin")) {
        let webapp_redirect = document.querySelector('#header_login');
        webapp_redirect.click();
    }
});

document.addEventListener('cf:customer_save_failed', function(event) {
    var errors = event.detail.errors;
    if(errors.hasOwnProperty('email')){
      var emailErrors = errors.email;
      if(emailErrors.includes("has already been taken")){
        const emailElm = document.querySelector('.cf-field.email');
        if(emailElm){
            const emailErrorElm = document.querySelector('.cf-field.email .cf-field-errors');
            emailElm.setAttribute('data-cf-invalid', true);
            if(!emailErrorElm){
                const emailInput = document.querySelector('.cf-field.email [data-cf-column-key="email"]');
                var registrationFromElm = document.querySelector('#form-registration');
                const emailErrorMessage = "This email address is already associated with an existing account. Please try using a different email address or log in using your existing account.";
                emailInput.insertAdjacentHTML('afterend', `<ul id="emailError" class="cf-field-errors"><li><div data-reach-alert="true">${emailErrorMessage}</div></li></ul>`);
                registrationFromElm.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        }    
      }    
    }
    if(errors.hasOwnProperty('phone')){
        var phoneErrors = errors.phone;
        
        if(phoneErrors.includes("has already been taken")){
          const phoneElm = document.querySelector('.cf-field.mobile');
          if(phoneElm){
              const phoneErrorElm = document.querySelector('.cf-field.mobile .cf-field-errors');
              phoneElm.setAttribute('data-cf-invalid', true);
              if(!phoneErrorElm){
                  const phoneInput = document.querySelector('.cf-field.mobile .cf-phone-field');
                  var registrationFromElm = document.querySelector('#form-registration');
                  const phoneErrorMessage = "Error: This phone number is already associated with an existing account. Please try using a different phone or log in using your existing account.";
                  phoneInput.insertAdjacentHTML('afterend', `<ul id="phoneError" class="cf-field-errors"><li><div data-reach-alert="true">${phoneErrorMessage}</div></li></ul>`);
                  registrationFromElm.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
              }
          }    
        }    
    }
});

document.addEventListener("input", function(e){
    const target = e.target.closest('.cf-field.email [data-cf-column-key="email"]');
    if(target){
      const emailErrorElm = document.querySelector('.cf-field.email #emailError');
        if(emailErrorElm){
            const emailErrorElm = document.querySelector('.cf-field.email .cf-field-errors');
            const emailElm = document.querySelector('.cf-field.email');
            emailElm.setAttribute('data-cf-invalid', false);
            emailErrorElm.remove();
        }
    }
  });